module.exports = __webpack_public_path__ + "static/10-7e8dbc2afe7ca73d75ffb3a85afe756f.jpg";